<template>
  <div>
    <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>
    <div class="login-view" :class="{ login: onlyLogin, 'get-started': onlyGetStarted }">
      <div class="login-form-container">
        <div v-if="onlyLogin" class="login-back-button">
<!--          <div>-->
<!--            <span class="txt-button-blue" @click="onlyLogin = false; onlyGetStarted= true;">-->
<!--              <v-icon class="ml-2" color="primary">fas fa-chevron-left</v-icon> BACK-->
<!--            </span>-->
<!--          </div>-->
          <div class="itovi-logo">
            <img src="../assets/itovi_blue.png">
          </div>
        </div>
        <div class="login-form">
          <div class="content-wrapper" v-if="!forgotPassword">
            <div class="header">LOGIN</div>
            <div class="inputs-container">
              <div class="input-field">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    placeholder=" "
                    required
                ></v-text-field>
              </div>
              <div class="input-field">
                <v-text-field
                    v-model="password"
                    v-on:keydown.enter="login"
                    :rules="passwordRules"
                    type="password"
                    label="Password"
                    placeholder=" "
                    required
                ></v-text-field>
                <div class="forgot-password">
                  <span @click="forgotPassword = true; email = ''" class="txt-button-blue">FORGOT PASSWORD</span>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button @click="login" class="button-blue">LOGIN</button>
            </div>
          </div>
          <div class="content-wrapper" v-else>
            <div class="header">RESET PASSWORD</div>
            <div class="inputs-container">
              <div class="input-field">
                <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    placeholder=" "
                    required
                ></v-text-field>
              </div>
              <div class="input-field">
                <div class="forgot-password">
                  <span @click="forgotPassword = false; email = ''" class="txt-button-blue">LOGIN</span>
                </div>
              </div>
              <div class="button-container">
                <button @click="sendPasswordResetLink" class="button-blue">Send Email</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="getting-started-container">
        <div class="getting-started-wrapper">
          <div class="getting-started">
            <div class="content-wrapper">
              <div class="itovi-logo">
                <img src="../assets/images/itovi_logo_white.png">
              </div>
<!--              <div class="header">LETS GET <span>STARTED!</span></div>-->
              <div class="intro">
                Access the industry’s leading technology to provide<br>
                customized recommendations for your wellness.<br>
                Oils, supplements, & more!
              </div>
<!--              <div class="button-container">-->
<!--                <button class="button-white-outline">SIGN UP</button>-->
<!--              </div>-->
              <div class="button-container" v-if="onlyGetStarted === true">
                <button class="button-white-outline" @click="onlyLogin = true; onlyGetStarted = false">LOGIN</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.success ? 'success' : 'error'"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.success ? snackbar.successMessage : snackbar.errorMessage }}
        <v-icon
            dark
            flat
            style="margin-left: 10px;"
            @click="snackbar.show = false">fas fa-times</v-icon>
    </v-snackbar>
  </div>
</template>

<style lang="scss" scoped>
  .login-header-card {
    border-radius: 0;
  }
  h1 {
    color: white;
    font-family: 'IBM Plex Serif', serif;
    font-weight: 400;
    font-size: 32pt;
  }
</style>

<script>
  // import Api from '../services/api'
  import auth from '../auth'
  import LoadingDialog from "../components/LoadingDialog"
  import api from "@/services/api_endpoints";

  export default {
    components: {
      LoadingDialog
    },
    data: () => ({
      window: {
        width: 0,
        height: 0
      },
      onlyLogin: false,
      onlyGetStarted: false,
      showLoadingDialog: false,
      snackbar: {
        show: false,
        timeout: 0,
        success: true,
        successMessage: "Email sent",
        errorMessage: "Invalid email",
      },
      email: '',//'testing@oddmob.com',
      password: '',//'1234',
      valid: true,
      name: '',
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+/.test(v) || 'email must be valid'
      ],
      checkbox: false,
      forgotPassword: false
    }),
    created () {
      if (auth.loggedIn())
        this.$router.replace('/')

      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    },
    methods: {
      async login () {
        this.showLoadingDialog = true
        const loggedIn = await auth.login(this.email, this.password)
        // console.log('loggedIn', loggedIn)
        this.showLoadingDialog = false

        if (!loggedIn) {
          this.snackbar.show = true
          this.snackbar.success = false
        } else {
          this.$router.replace(this.$route.query.redirect || '/')
        }

      },
      async sendPasswordResetLink () {
        this.showLoadingDialog = true
        const emailSent = await api.sendPasswordReset(this.email)
        console.log('emailSent', emailSent)
        this.showLoadingDialog = false
        this.snackbar.show = true;
        this.snackbar.success = emailSent;
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      validate () {
        this.$refs.form.validate()
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;

        if(window.innerWidth <= 1023) {
          this.onlyGetStarted = false;
          this.onlyLogin = true;
        } else {
          this.onlyGetStarted = false;
          this.onlyLogin = false;
        }
      }
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
  }
</script>
